var PageTracker = function(data) {
	var _pt = this;

	var ga,
		uetq,
		requests,
		numComplete = 0;

	var init = function() {
		publish();
	};

	var publish = function() {
		_pt.track = track;
		_pt.getOnCompleteRedirect = getOnCompleteRedirect;
	};

	var track = function() {

		requests = [].concat(
			bingTransaction() || [],
			ebayTransaction() || [],
			googleTransaction() || [],
			adWords() || [],
            listrak() || [],
            listrakTransaction() || [],
            optimizely() || []
		);

		if (!requests.length)
			complete();

		$.each(requests, function(i, request) {
			request(requestComplete);
		});

	};

	var getOnCompleteRedirect = function() {
		return data.onCompleteRedirect;
	};

	var complete = function() {
		if (data.onCompleteRedirect)
			setTimeout(function() {
				window.location.href = data.onCompleteRedirect;
			}, 500);
	};

    var requestComplete = function() {
		numComplete++;

		if (requests.length == numComplete)
			complete();

	};

	var bingTransaction = function() {
		var sale = data.trackSale;

        if (
            !sale
            || !uetq
            || data.isInternalUser
        )
            return;

		dataLayer.push({
            'event' : 'bingTransaction',
			'gv'    : sale.total
		});

	};

	var ebayTransaction = function() {
		var sale = data.trackSale;

		if (
			!sale
			|| !data.ebayMerchantID
		)
			return;

		var _roi = _roi || [];

		_roi.push(['_setMerchantId', data.ebayMerchantID]);
		_roi.push(['_setOrderId', sale.id]);
		_roi.push(['_setOrderAmount', (
			sale.total
			- sale.shipping
			- sale.tax
		)]);
		_roi.push(['_setOrderNotes', '']);

		$.each(sale.items, function(i, item) {
			_roi.push(['_addItem',
				item.sku, // Merchant sku
				item.name, // Product name
				'', // Category id
				item.category, // Category name
				item.price, // Unit price
				item.quantity // Item quantity
			]);
		});

		_roi.push(['_trackTrans']);

		window._roi = _roi;

		return [function (callback) {
			loadScript(
				'https://stat.dealtime.com/ROI/ROI2.js',
				callback
			)
		}];
	};

	var googleTransaction = function() {
		var sale = data.trackSale,
			products = [];

		if (!sale) return;

		$.each(sale.items, function(i, item) {
			products.push({
				'id'          : sale.id,
				'name'        : item.name,
				'sku'         : item.sku,
				'category'    : item.category,
				'price'       : item.price,
				'quantity'    : item.quantity,
			});
		});

		dataLayer.push({
            'event'                  : 'gaTransaction',
            'transactionId'          : sale.id,
			'transactionAffiliation' : 'EStore',
			'transactionTotal'       : sale.total,
			'transactionShipping'    : sale.shipping,
			'transactionTax'         : sale.tax,
            'transactionProducts'    : products
		});

		return requestComplete;
	};

    var adWords = function() {
        var sale = data.trackSale;
        var accounts = data.adWordsAccounts || [];

        // ECS Checkout tag fires only on internal sales
        if( !sale || (data.isInternalUser == 'external') ) {
            return;
        }

        if( accounts[0] ) {
            $.each(accounts, function(i, account) {
                dataLayer.push({
                    'event'                  : 'adwordsTransaction',
                    'adwordsConversionID'    : account.id,
                    'adwordsConversionLabel' : account.label,
                    'adwordsConversionValue' : sale.total
                });
            });

            return requestComplete;
		}
        else {
            return;
        }
	};

	var optimizely = function () {
		var sale = data.trackSale;
		if (!sale) 
			return; 
		if ( !window.optimizely)
			return;
		var valueInCents = parseInt( sale.total * 100 ); 
		window.optimizely.push(['trackEvent', 'sales', {'revenue': valueInCents}]);
	};


	var loadImg = function(url, callback) {
		$('<img src="'+url+'" height="1" width="1" border="0" />')
			.on('load', callback)
			.on('error', callback)
			.appendTo('body');
	};

	var loadScript = function(url, callback) {
		$.getScript(url)
			.done(callback)
			.fail(callback);
	};

    var listrak = function() {
        var emailFields = [
            'email',
            'email_login',
            'emailConfirm',
            'checkout-login-email',
            'targetEmail',
            'addressForm_email',
        ];

        return function(callback) {
            // bail out if the library failed to load
            if(typeof _ltk == "undefined") return callback();

            $.each(emailFields, function(i, emailField) {
                _ltk.SCA.CaptureEmail( emailField );
            });

            // the partnumber from product landing pages only
            var partnumber = $(".js-product .js-partnumber").html();

            if(partnumber) {
                var browsedProducts = [];
                if (localStorage.browsedProducts) {
                    browsedProducts = JSON.parse(localStorage.browsedProducts);
                }
                // if this product already part of previous 5 products, skip rebuilding productBrowsed
                if ($.grep( browsedProducts, function( a ) {return a.url == window.location.pathname + window.location.search}).length == 0) {
                    if (browsedProducts.length == 5) {
                        browsedProducts.shift();
                    }
                    var $image = $(".js-mainImage");
                    var $title = $(".js-title");
                    browsedProducts.push({
                        imageURL : $image.attr('href'),
                        title : $title.html().trim(),
                        url : window.location.pathname + window.location.search,
                    });
                    localStorage.browsedProducts = JSON.stringify(browsedProducts);
                }
                var productBrowsed = {};
                $.each(browsedProducts, function(i, data) {
                    var index = i + 1;
                    productBrowsed['ImageURL' + index] = data.imageURL;
                    productBrowsed['ProductTitle' + index] = data.title;
                    productBrowsed['LinkUrl' + index] = data.url;
                });
                _ltk.Activity.AddProductBrowse( partnumber, productBrowsed);
            }
            else {
                _ltk.Activity.AddPageBrowse();
            }

            if ( $( '#footerEmailSignupModal' ).length ) {
                var subscriberID = 'Modal';
                _ltk.Signup.New(
                    subscriberID,           // Subscriber ID
                    '#cta-email',           // Input ID
                    _ltk.Signup.TYPE.CLICK, // Form Type
                    '#cta-sign-up',         // Button ID
                    'email',                // Channel
                );
                //                    Subscriber ID, Input ID,         Options
                _ltk.Signup.SetField( subscriberID,  '#cta-firstname', { 'key': 'firstname' } );
                _ltk.Signup.SetField( subscriberID,  '#cta-lastname',  { 'key': 'lastname' } );
            }

            _ltk.Activity.Submit();
            callback();
        };
    };

    var listrakTransaction = function() {
        var sale = data.trackSale;
        if(! sale) return;

        var customer = sale.customer;

        return function(callback) {
            /* Handle Order */
            // bail out if the library failed to load
            if(typeof _ltk == "undefined") return callback();
            _ltk.Order.SetCustomer( customer.email, customer.first_name, customer.last_name );
            _ltk.Order.OrderNumber = sale.id;

            /* Add the items */
            var itemTotal = 0;
            $.each( sale.items, function(i, item) {
                _ltk.Order.AddItem( item.sku, item.quantity, item.price );

                var qtyVal = parseInt( item.quantity, 10 ) || 0;
                var priceVal = parseFloat( item.price ) || 0;
                itemTotal += qtyVal * priceVal;
            });

            _ltk.Order.ItemTotal = itemTotal;
            _ltk.Order.OrderTotal = sale.total;
            _ltk.Order.TaxTotal = sale.tax;
            _ltk.Order.ShippingTotal = sale.shipping;
            _ltk.Order.HandlingTotal = "0.00";
            _ltk.Order.Submit();

            /* Handle SCA Removal */
            _ltk.SCA.SetCustomer( customer.email, customer.first_name, customer.last_name);
            _ltk.SCA.OrderNumber = sale.id;
            _ltk.SCA.Submit();

            callback();
        };
    };

	init();
};
